/**
 * Cold-start mitigation for the free-tier API (visualte-api on Render).
 *
 * 1. warmBackend(): fire-and-forget /api/health ping on first page load, so the
 *    server is waking while the visitor is still reading the static page.
 * 2. keepEnginesRunning(): while a tab is open and visible, ping every 10 minutes
 *    (a safe margin under Render's 15-minute idle limit). When no tab is open,
 *    the server's own loop (backend/keepawake.py) takes over.
 */
import api from './api';

let warmed = false;
export function warmBackend() {
  if (warmed) return;
  warmed = true;
  api.get('/api/health', { timeout: 90000 }).catch(() => {
    /* it woke the server; the outcome doesn't matter */
  });
}

const KEEP_AWAKE_MS = 10 * 60 * 1000;
let keepAliveTimer = null;
export function keepEnginesRunning() {
  if (keepAliveTimer || typeof window === 'undefined') return () => {};
  const tick = () => {
    if (document.visibilityState === 'hidden') return;
    api.get('/api/health', { timeout: 90000 }).catch(() => {});
  };
  const onVisible = () => {
    if (document.visibilityState === 'visible') tick();
  };
  keepAliveTimer = setInterval(tick, KEEP_AWAKE_MS);
  document.addEventListener('visibilitychange', onVisible);
  return () => {
    clearInterval(keepAliveTimer);
    keepAliveTimer = null;
    document.removeEventListener('visibilitychange', onVisible);
  };
}
